import React, { Fragment } from "react";
import { Row, Col } from "~/components/.base/containers";
import { Subheading, BodyText, BodyTextAlt } from "~/components/.base/headings";
import ClockIcon from "~/images/icons/location_clock.svg";

const RestaurantSchedule = ({ restaurantSchedule }) => {
	return (
		<Row className="schedule-items restaurant">
			{restaurantSchedule ? (
				<Fragment>
					<Col className="schedule-col">
						{restaurantSchedule.sundayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.sundayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.sundayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
					<Col className="schedule-col">
						{restaurantSchedule.mondayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.mondayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.mondayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
					<Col className="schedule-col">
						{restaurantSchedule.tuesdayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.tuesdayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.tuesdayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
					<Col className="schedule-col">
						{restaurantSchedule.wednesdayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.wednesdayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.wednesdayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
					<Col className="schedule-col">
						{restaurantSchedule.thursdayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.thursdayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.thursdayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
					<Col className="schedule-col">
						{restaurantSchedule.fridayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.fridayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.fridayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
					<Col className="schedule-col">
						{restaurantSchedule.saturdayHours ? (
							<div className="schedule-item">
								<ClockIcon />
								<BodyTextAlt
									md="6px 0"
									style={{ maxWidth: "90px" }}
								>
									{restaurantSchedule.saturdayHours}
								</BodyTextAlt>
								<BodyText>
									{restaurantSchedule.saturdayNote}
								</BodyText>
							</div>
						) : (
							<div className="empty-date" />
						)}
					</Col>
				</Fragment>
			) : null}
		</Row>
	);
};

export default RestaurantSchedule;
